import { jsx as r, jsxs as c, Fragment as p } from "react/jsx-runtime";
import { s as i } from "../../../vendor-CPVnY93G.js";
import "react";
import "../../../theme/spacing.js";
import { omitStyleRenderProps as s } from "../../../utils/omitStyleRenderProps/index.js";
import { ItemRow as t } from "../../ItemRow/index.js";
const S = ({ children: e, ...m }) => /* @__PURE__ */ r(t, { as: i, ...s(m), children: (o) => {
  const n = o.hasSubmenu ? /* @__PURE__ */ r(t.Submenu, {}) : o.selectionMode !== "none" ? /* @__PURE__ */ r(t.Selectable, {}) : null;
  return /* @__PURE__ */ c(p, { children: [
    typeof e == "function" ? e(o) : e,
    n
  ] });
} });
export {
  S as Item
};
